import { createModel } from "hox";
import { TablePaginationConfig } from "antd/es/table/interface";
import { IPgProps, ISearchPage } from "@/types/ScmTypes";
import React, { useState, useEffect } from "react";
import { PaginationProps } from "antd/es/pagination";
import {
    DEFAULT_FIRST_PAGE_NUM,
    DEFAULT_PAGE_SIZE,
} from "@/utils/constants";
import {
    IStockDeliveryField,
    IStockDeliverySearch,
    IStockDeliveryDetail,
} from "./stockOutDispatchType"
import { stockOutDispatchService } from "./stockOutDispatchService"
import { sourceAppOrBranch } from "@/types/VrmSaDictEnums";
import useGlobalModel from "@/model/globalModel";
import { transPgToPagination } from "@/utils/utils";


export interface IMdBeSearchField {
    code?: string;
    name?: string;
    corporation?: string;
    phone?: string;
    address?: string;
    bank?: string;
    bankAccount?: string;
}

export const useStockOutDispatchModel = createModel(function () {
    const { shopAndOrg } = useGlobalModel(({ shopAndOrg }) => [shopAndOrg])
    //切换站点清除缓存
    useEffect(() => {
        // setSelectedRowKeys([]);
        reset()
    }, [shopAndOrg.shopCode])

    const initSearchParam: IStockDeliverySearch = {};
    const initDataSource: IStockDeliveryDetail[] = [];
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }

    //查询条件
    const [searchParam, setSearchParam] = useState<IStockDeliverySearch>(initSearchParam);
    //列表数据源
    const [dataSource, setDataSource] = useState<IStockDeliveryDetail[]>(initDataSource);
    //表格选中行Key值
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
    //表格选中的值
    const [selectedRow, setSelectedRow] = useState<IStockDeliveryDetail>({});
    //列表数据源分页参数
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);

    useEffect(() => {
        let filters = dataSource.filter(el => selectedRowKeys.length > 0 ? el.id === selectedRowKeys[0] : false);
        const selectedData = filters && filters.length > 0 ? filters[0] : undefined;
        setSelectedRow(selectedData as IStockDeliveryDetail)
    }, [selectedRowKeys])

    const [drawerVisible, setDrawerVisible] = useState(false);

    const updatePgCfg = (updateParam: TablePaginationConfig) => {
        setPgCfg({ ...pgCfg, ...updateParam })
    }
    const updateSearchParam = (updateParam: IStockDeliveryField) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }
    const resetSearchParam = () => {
        setSearchParam(initSearchParam);
        loadData(initPgCfg, {});
        setSelectedRowKeys([])
    }
    const reset = () => {
        setSearchParam(initSearchParam);
        setSelectedRowKeys([])
    }
    const loadData = async (page?: ISearchPage, searchValue: IStockDeliverySearch = searchParam) => {
        const shopParam = {
            shopType: searchValue.shopId !== undefined ? 1 : shopAndOrg.shopType,
            shopId: searchValue.shopId ?? shopAndOrg.shopId
        };
        const searchParams = {
            ...searchValue,
            ...shopParam,
            ...sourceAppOrBranch,
            pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.pageNum || page?.current) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
        }
        let { retData } = await stockOutDispatchService.page(searchParams);
        const { records, ...pg } = retData;
        setPgCfg(transPgToPagination(pg));
        setDataSource(records);
    }
    return {
        /***field***/
        searchParam,
        dataSource,
        selectedRowKeys,
        pgCfg,
        drawerVisible,
        initPgCfg,
        /***method***/
        setDataSource,
        setSelectedRowKeys,
        resetSearchParam,
        updateSearchParam,
        loadData,
        updatePgCfg,
        setDrawerVisible,
        selectedRow, setSelectedRow,
        reset
    }
});